import { render, staticRenderFns } from "./Evidences.vue?vue&type=template&id=90fea064&scoped=true&"
import script from "./Evidences.vue?vue&type=script&lang=js&"
export * from "./Evidences.vue?vue&type=script&lang=js&"
import style0 from "./Evidences.vue?vue&type=style&index=0&id=90fea064&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fea064",
  null
  
)

export default component.exports